import React from 'react'
import PropTypes from 'prop-types'
import ListItem from '@mui/material/ListItem'
import Drawer from '@mui/material/Drawer'
import KeyboardArrowLeftOutlinedIcon from '@mui/icons-material/KeyboardArrowLeftOutlined'
import './style.css'
import { styled } from '@mui/material/styles'
import { Button, CircularProgress } from '@mui/material'

export const StyledListItem = styled(ListItem)(() => ({
  color: '#6D7B8E !important',
  height: '35px',
  '&:hover': {
    backgroundColor: '#0080ff24 !important',
    color: '#1976d2 !important',
    '& .IconListItem': {
      color: '#1976d2 !important',
    },
  },
}))

export default function DrawerDateFilter({
  filterLabel,
  disabled,
  content,
  toggleDrawer,
  opentDrawer,
  Icon,
  id,
  actionButtons,
  annulationDate,
  checkedTodayDate,
  onCancel,
  isLoading,
}) {
  return (
    <>
      <StyledListItem
        button
        disabled={disabled}
        onClick={(event) => toggleDrawer(true, event)}
        id={id}
      >
        {isLoading ? (
          <div
            style={{
              display: 'flex',
              alignSelf: 'center',
            }}
          >
            <CircularProgress
              sx={{
                width: '20px !important',
                height: '20px !important',
                marginRight: '9px',
              }}
            />
          </div>
        ) : (
          <Icon className="IconListItem" />
        )}

        <span>{filterLabel}</span>
      </StyledListItem>
      <Drawer
        anchor={'right'}
        open={opentDrawer}
        onClose={(event) => toggleDrawer(false, event)}
        PaperProps={{
          sx: {
            top: 120,
            boxShadow:
              'inset 1px 0 0 #dadce0, inset -1px 0 0 #dadce0, 0 1px 2px 0 rgb(60 64 67 / 30%), 0 0px rgb(60 64 67 / 15%)',
          },
        }}
        BackdropProps={{ invisible: true }}
        style={{ zIndex: 2 }}
      >
        <div role="presentation" style={{ width: 280 }}>
          <div
            style={{
              display: 'flex ',
              alignItems: 'center',
              fontSize: '13px',
              paddingTop: '15px',
              fontWeight: '600',
            }}
          >
            <KeyboardArrowLeftOutlinedIcon
              style={{
                cursor: 'pointer',
                marginRight: '2px',
                width: '20px',
                height: '20px',
              }}
              onClick={(event) => toggleDrawer(false, event)}
            />
            {filterLabel}
          </div>
          <div style={{ height: 'calc(-223px + 100vh)', overflowY: 'auto' }}>
            {content}
            {actionButtons}
          </div>
          {annulationDate && (
            <div
              style={{
                padding: '10px 20px',
                bottom: '0',
                position: 'fixed',
                width: '280px',
                background: 'white',
              }}
            >
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'center',
                  paddingTop: '18px',
                }}
              >
                <Button
                  id={`Annuler-date`}
                  variant="contained"
                  color="primary"
                  onClick={onCancel}
                  sx={{
                    width: '130px',
                    height: '40px',
                    color: 'white',
                    textTransform: 'none',
                    fontSize: '13px',
                    fontWeight: '400',
                    backgroundColor: '#f61057',
                    ':hover': {
                      backgroundColor: '#d32f2f',
                    },
                  }}
                  disabled={checkedTodayDate}
                >
                  {'Annuler la date'}
                </Button>
              </div>
            </div>
          )}
        </div>
      </Drawer>
    </>
  )
}
DrawerDateFilter.propTypes = {
  disabled: PropTypes.bool,
  filterLabel: PropTypes.string,
  content: PropTypes.any,
  toggleDrawer: PropTypes.func,
  opentDrawer: PropTypes.bool,
  Icon: PropTypes.any,
  id: PropTypes.string,
  actionButtons: PropTypes.any,
  annulationDate: PropTypes.bool,
  checkedTodayDate: PropTypes.bool,
  onCancel: PropTypes.func,
  isLoading: PropTypes.bool,
}
